import React from "react";
import { Box, Card, CardContent, Grid, Skeleton, Typography } from "@mui/material";

export const TodayOverviewSkeleton: React.FC = () => {
  return (
    <Box>
      <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 1 }}>
        <Typography variant="h3">Today's Overview</Typography>
        <Skeleton variant="rectangular" width={140} height={24} sx={{ borderRadius: 12 }} />
      </Box>

      <Grid container spacing={3}>
        {[1, 2, 3].map((i) => (
          <Grid item xs={12} md={4} key={i}>
            <Card
              sx={{
                height: "100%",
                background: "#f8fafb",
                border: "1px solid #eaecf0",
                borderRadius: 0.75,
                boxShadow: "0px 1px 3px rgba(0, 0, 0, 0.1)",
              }}
            >
              <CardContent sx={{ display: "flex", flexDirection: "column", gap: 1, "&:last-child": { paddingBottom: 2 } }}>
                <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
                  <Skeleton variant="text" width={120} height={16} />
                </Box>

                <Box sx={{ display: "flex", flexDirection: "column", gap: 0.5 }}>
                  <Skeleton variant="text" width={150} height={28} />
                  <Skeleton variant="text" width={200} height={20} />
                </Box>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};
